export default function HowItWorks() {
  const steps = [
    { step: '01', icon: 'ri-folder-open-line', title: 'Browse Categories', desc: 'Explore our organized spreadsheet categories to find exactly what you are looking for.' },
    { step: '02', icon: 'ri-scales-3-line', title: 'Compare Products', desc: 'Review product details, pricing, and seller ratings side by side before deciding.' },
    { step: '03', icon: 'ri-information-line', title: 'Check Information', desc: 'Verify all product specifications, shipping details, and quality assessments.' },
    { step: '04', icon: 'ri-shopping-bag-3-line', title: 'Complete Purchase', desc: 'Head to our partner store to complete your purchase with confidence.' },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/70 mb-5">
            <span className="text-xs font-medium text-primary-700 tracking-wide">How It Works</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            How Sugargoo Spreadsheet Works
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            Four simple steps from discovery to purchase. It has never been easier to find great products.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {steps.map((s, i) => (
            <div key={s.step} className="relative text-center group">
              <div className="bg-background-50 rounded-2xl p-6 border border-background-200/60 hover:border-primary-200 transition-all duration-300">
                <span className="inline-block font-heading text-4xl font-bold text-background-300 mb-3">{s.step}</span>
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-accent-100 mb-4">
                  <i className={`${s.icon} text-accent-600 text-xl`}></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-800 mb-2">{s.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{s.desc}</p>
              </div>
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-foreground-300 text-lg"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}